'use client';

import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { Column, Spinner } from '@viewup/ui';
import { AuthBox } from 'app/_components/AuthBox';
import { PopupModal } from 'app/_components/PopupModal';
import jwtDecode from 'jwt-decode';
import { Suspense, useEffect } from 'react';
import { AutoViewingEndNoticeModal, useAutoViewingEndNotice } from '../AutoViewingEndNoticeModal';
import { EarnedRanking } from '../EarnedRanking';
import { EventBanner } from '../EventBanner';
import { Footer } from '../Footer';
import { NewViewing } from '../NewViewing';
import { RenewalNoticeModal, useRenewalNotice } from '../RenewalNoticeModal';
import { ViewingMenus } from '../ViewingMenus';
import { ViewupTips } from '../ViewupTips';
import { ViewupUsage } from '../ViewupUsage';
import { usePopupLists } from './usePopupLists';

export const MainClientPage = () => {
  const { accessToken } = useTokenStore();
  const popupLists = usePopupLists();
  const {
    isOpen: isEndNoticeOpen,
    isChecked: isEndNoticeChecked,
    close: closeEndNotice,
    goNotice: goEndNoticePage,
    hideToday: hideEndNoticeToday,
  } = useAutoViewingEndNotice();
  const {
    isOpen: isRenewalNoticeOpen,
    isChecked: isRenewalNoticeChecked,
    close: closeRenewalNotice,
    hideToday: hideRenewalNoticeToday,
    start: startRenewalApp,
    variant: renewalNoticeVariant,
  } = useRenewalNotice();

  // GA를 위한 dataLayer 설정
  useEffect(() => {
    if (!accessToken) return;

    try {
      const userUuid = jwtDecode<{ userUuid: string }>(accessToken)?.userUuid;

      if (!userUuid) return;

      const dataLayer = window.dataLayer || [];
      dataLayer.push({
        gtm: {
          user_id: userUuid,
        },
        user_id: userUuid,
        user_uuid: userUuid,
      });
    } catch (_e) {
      //
    }
  }, [accessToken]);

  return (
    <Column height='100%' justifyContent='space-between'>
      <Suspense fallback={<Spinner variant='bar' />}>
        <Column>
          <Column bgColor='bg.disabledLight'>
            <AuthBox />
            <ViewingMenus />
          </Column>
          <Column bgColor='bg.primary' gap={24} pb={48} pt={24} px={24}>
            <EventBanner />
            <NewViewing />
            <EarnedRanking />
            <ViewupUsage />
            <ViewupTips />
          </Column>
          <Footer />
          {/* 팝업 우선순위: 종료 안내 → 리뉴얼 안내 → 이벤트 팝업. 앞 팝업 판정이 끝나고 닫힌 뒤에야 다음이 열린다.
              useRenewalNotice 는 마운트 즉시 isOpen=true 를 세팅하므로 호출부에서 종료 안내 상태와 AND 한다. */}
          <AutoViewingEndNoticeModal
            isOpen={isEndNoticeOpen}
            onClickNotice={goEndNoticePage}
            onClose={closeEndNotice}
            onHideToday={hideEndNoticeToday}
          />
          <RenewalNoticeModal
            isOpen={isEndNoticeChecked && !isEndNoticeOpen && isRenewalNoticeOpen}
            onClickStart={startRenewalApp}
            onClose={closeRenewalNotice}
            onHideToday={hideRenewalNoticeToday}
            variant={renewalNoticeVariant}
          />
          {isEndNoticeChecked &&
            !isEndNoticeOpen &&
            isRenewalNoticeChecked &&
            !isRenewalNoticeOpen && <PopupModal items={popupLists} />}
        </Column>
      </Suspense>
    </Column>
  );
};
